<template>
  <button 
    type="button" 
    class="solution-icon" 
    :class="{ active: isActive }" 
    v-on="isMobileView ? { click: toggleActive } : { mouseover: setActive }" 
  >
    <div class="icon-wrapper">

      <svg v-if="item.icon == 'koala'" width="108" height="88" viewBox="0 0 108 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M87.8312 0.5C83.4812 0.5 70.9146 0.5 65.1146 15.4833C63.1812 15 60.7646 15 58.8312 15H49.1646C47.2312 15 44.8146 15 42.8812 15.4833C37.0812 0.5 24.5146 0.5 20.1646 0.5C15.3312 0.5 0.831238 5.33333 0.831238 29.5C0.831238 46.9 12.9146 51.7333 20.1646 53.1833V58.5C20.1646 74.45 33.2146 87.5 49.1646 87.5H58.8312C74.7812 87.5 87.8312 74.45 87.8312 58.5V53.1833C95.0812 51.7333 107.165 46.9 107.165 29.5C107.165 5.33333 92.6646 0.5 87.8312 0.5ZM20.1646 44V45.9333C10.0146 43.0333 11.9479 31.9167 16.7812 28.05C15.3312 26.1167 10.4979 29.5 10.4979 27.5667C10.4979 25.15 19.1979 21.7667 20.6479 21.2833C19.1979 18.8667 13.3979 19.8333 13.3979 17.9C13.3979 16.45 19.1979 14.0333 24.0312 15C26.4479 15.4833 29.3479 16.45 31.7646 18.3833C24.9979 24.6667 20.1646 33.3667 20.1646 44ZM37.0812 58.5C27.4146 58.5 27.4146 44 37.0812 44C46.7479 44 46.7479 58.5 37.0812 58.5ZM56.4146 73H51.5812C48.1979 73 45.7812 69.6167 47.2312 66.7167L50.6146 52.2167C51.0979 50.2833 53.0312 49.3167 54.4812 48.8333C55.9312 48.8333 57.3812 49.8 58.3479 52.2167L61.7312 66.7167C62.2146 69.6167 59.7979 73 56.4146 73ZM70.9146 58.5C61.2479 58.5 61.2479 44 70.9146 44C80.5812 44 80.5812 58.5 70.9146 58.5ZM91.2146 27.5667C96.0479 31.4333 97.9812 42.55 87.8312 45.45C88.3146 34.8167 83.4812 24.6667 76.2312 18.3833C78.6479 16.45 81.5479 15.4833 83.9646 15C88.7979 14.0333 94.5979 15.9667 94.5979 17.9C94.5979 19.8333 88.7979 18.8667 87.3479 20.8C88.7979 21.7667 97.4979 25.15 97.4979 27.5667C97.4979 29.5 93.1479 26.1167 91.2146 27.5667Z" fill="currentColor"/>
      </svg>

      <svg v-if="item.icon == 'tree'" width="75" height="88" viewBox="0 0 75 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.082 87.5V66.91C27.7712 67.7317 25.3129 68.1667 22.707 68.1667C10.4154 68.1667 0.582031 58.5 0.582031 46.4167C0.582031 40.2783 3.04036 34.7683 7.2687 30.805C6.13786 28.195 5.4987 25.295 5.4987 22.25C5.4987 10.1667 15.332 0.5 27.6237 0.5C35.2937 0.5 42.0787 4.36667 46.0612 10.1667C46.4545 10.1667 46.8479 10.1667 47.2904 10.1667C50.8415 10.1667 54.3579 10.8543 57.6388 12.1902C60.9196 13.5261 63.9006 15.4843 66.4117 17.9527C68.9227 20.4212 70.9146 23.3518 72.2736 26.577C73.6326 29.8022 74.332 33.259 74.332 36.75C74.332 40.241 73.6326 43.6978 72.2736 46.923C70.9146 50.1482 68.9227 53.0788 66.4117 55.5473C63.9006 58.0158 60.9196 59.9739 57.6388 61.3098C54.3579 62.6457 50.8415 63.3333 47.2904 63.3333C44.832 63.3333 42.3737 62.995 39.9154 62.3183V87.5H30.082Z" fill="currentColor"/>
      </svg>

      <svg v-if="item.icon == 'renewable'" width="97" height="85" viewBox="0 0 97 85" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M73.032 0.160334C70.9828 0.147817 68.9836 0.798222 67.3278 2.01608C65.672 3.23395 64.4468 4.95513 63.832 6.927L59.9987 19.252C58.2335 19.3176 56.4955 19.7109 54.8716 20.412L46.1029 10.8903L39.7299 3.737C38.8002 4.59604 38.0476 5.6317 37.5154 6.78464C36.9831 7.93758 36.6816 9.18513 36.6282 10.4558C36.5748 11.7265 36.7705 12.9953 37.2041 14.1895C37.6377 15.3838 38.3006 16.48 39.1549 17.4153L47.8279 26.937C47.4017 27.724 47.0488 28.5492 46.7737 29.402C46.5218 30.2381 46.3454 31.0955 46.2466 31.9637L33.7404 34.767L24.3487 36.8937C24.6208 38.1354 25.1331 39.3108 25.8564 40.3525C26.5796 41.3942 27.4995 42.2817 28.5633 42.9642C29.6272 43.6467 30.814 44.1107 32.056 44.3297C33.2979 44.5487 34.5705 44.5183 35.8008 44.2403L48.307 41.3887C49.2403 42.9024 50.4424 44.2296 51.8529 45.3037L48.0195 57.6287L45.1445 66.8603C47.5655 67.6174 50.1852 67.3762 52.4302 66.1896C54.6753 65.0029 56.3629 62.9675 57.1237 60.5287L61.0049 48.252C62.7701 48.1864 64.5082 47.7931 66.132 47.092L74.8529 56.6137L81.2258 63.7187C83.0959 61.9919 84.2114 59.5881 84.3282 57.0335C84.4449 54.4788 83.5533 51.9816 81.8487 50.0887L73.1758 40.567C73.5855 39.7782 73.9224 38.9531 74.182 38.102C74.4855 37.2549 74.7101 36.3811 74.8529 35.492L87.2633 32.6887L96.607 30.6103C96.0569 28.1127 94.5477 25.937 92.41 24.5599C90.2723 23.1828 87.6806 22.7167 85.2029 23.2637L72.6966 26.067C71.7586 24.5706 70.5568 23.2601 69.1508 22.2003L72.9841 9.827L75.8591 0.643668C74.9461 0.340457 73.9931 0.177522 73.032 0.160334ZM60.7654 26.502C61.4004 26.5309 62.0288 26.6447 62.6341 26.8403C64.4507 27.4181 65.9657 28.6997 66.8462 30.4035C67.7267 32.1073 67.9007 34.0939 67.3299 35.927C66.7571 37.7594 65.4866 39.2876 63.7975 40.1757C62.1084 41.0639 60.1389 41.2394 58.3216 40.6637C56.505 40.0859 54.99 38.8043 54.1095 37.1005C53.229 35.3968 53.055 33.4101 53.6258 31.577C54.096 30.0658 55.0439 28.7516 56.3245 27.8351C57.6052 26.9187 59.1481 26.4504 60.7174 26.502H60.7654ZM29.332 49.0737C23.4862 53.2303 16.8258 55.502 10.1654 55.502H0.582031V65.1687H10.1654C16.7299 65.1687 23.2945 63.477 29.332 60.3353C33.0216 62.2687 36.9029 63.5253 40.8799 64.2503L43.4195 56.1787L43.8508 54.922C38.7716 54.197 33.7883 52.2153 29.332 49.0737ZM88.9883 55.502C89.2279 58.8853 88.4133 62.317 86.4008 65.1687C86.4966 65.1687 86.6883 65.1687 86.832 65.1687H96.4154V55.502H88.9883ZM29.332 68.407C23.4862 72.5637 16.8258 74.8353 10.1654 74.8353H0.582031V84.502H10.1654C16.7299 84.502 23.2945 82.8103 29.332 79.6687C41.3112 85.952 55.6862 85.952 67.6654 79.6687C73.7029 82.8103 80.2195 84.502 86.832 84.502H96.4154V74.8353H86.832C80.1716 74.8353 73.5112 72.5637 67.6654 68.407C55.9737 76.672 41.0237 76.672 29.332 68.407Z" fill="currentColor"/>
      </svg>

      <svg v-if="item.icon == 'innovate'" width="89" height="90" viewBox="0 0 89 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M44.0039 20.4987C50.3691 20.4987 56.4736 23.0799 60.9745 27.6746C65.4753 32.2692 68.0039 38.5009 68.0039 44.9987C68.0039 54.0637 63.1639 61.9854 56.0039 66.232V73.582C56.0039 74.665 55.5825 75.7036 54.8323 76.4694C54.0822 77.2351 53.0648 77.6654 52.0039 77.6654H36.0039C34.943 77.6654 33.9256 77.2351 33.1755 76.4694C32.4253 75.7036 32.0039 74.665 32.0039 73.582V66.232C24.8439 61.9854 20.0039 54.0637 20.0039 44.9987C20.0039 38.5009 22.5325 32.2692 27.0333 27.6746C31.5342 23.0799 37.6387 20.4987 44.0039 20.4987ZM52.0039 81.7487V85.832C52.0039 86.915 51.5825 87.9536 50.8323 88.7194C50.0822 89.4851 49.0648 89.9153 48.0039 89.9153H40.0039C38.943 89.9153 37.9256 89.4851 37.1755 88.7194C36.4253 87.9536 36.0039 86.915 36.0039 85.832V81.7487H52.0039ZM76.0039 40.9154H88.0039V49.082H76.0039V40.9154ZM0.00390625 40.9154H12.0039V49.082H0.00390625V40.9154ZM48.0039 0.0820312V12.332H40.0039V0.0820312H48.0039ZM15.6839 10.2904L24.2039 19.0287L18.5239 24.7862L10.0039 16.1295L15.6839 10.2904ZM63.8039 18.9879L72.2839 10.2904L78.0039 16.1295L69.4839 24.7862L63.8039 18.9879Z" fill="currentColor"/>
      </svg>

    </div>

    <h4 class="wwf-font">{{ item.name }}</h4>
    <span class="arrow-open"><i class="fas fa-chevron-right"></i></span>
    <span class="arrow-more"><i class="fas fa-chevron-down"></i></span>
  </button>
</template>

<script>
export default {
  name: "SolutionsButton",

  props: {
    item: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
    },
  },
  data() {
    return {
      isMobileView: false
    }
  },

  created() {
    // To set click/toggle for collapsable list in mobile view
    const isMatch = window.matchMedia('(min-width: 768px)').matches;

    this.isMobileView = !isMatch;
  },
  methods: {
    setActive() {
      this.$emit("setActive");
    },
    toggleActive() {
      this.$emit("toggleActive");
    }
  },
};
</script>

<style scoped>
.solution-icon {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  text-align: left;
  background: linear-gradient(#bfbfbf, #d1d1d1);
}

.solution-icon h4 {
  margin: 0;
  font-size: 2rem;
  text-transform: uppercase;
}

.icon-wrapper svg {
  width: 3rem;
}

.active .arrow-open,
.active .icon-wrapper,
.active.solution-icon h4 {
  color: var(--wwfOrange);
}

.arrow-open,
.arrow-more {
  margin-left: auto;
}

.arrow-open {
  display: none;
}

.active .arrow-open {
  display: inline-block;
}

.active .arrow-more {
  display: none;
}

.wwf-font {
  font-family: "WWFRegular", sans-serif;
  font-weight: 400;
}

.active {
  background: var(--wwfGreyED);
}

@media only screen and (min-width: 768px) {
  .icon-wrapper svg {
    width: 5rem;
  }

  .solution-icon {
    flex-direction: column;
    background: none;
    text-align: center;
    color: #888888;
  }

  .solution-icon h4 {
    padding: 0 10%;
    color: #888888;
  }

  .arrow-more,
  .active .arrow-open {
    display: none;
  }

  .active {
    background: none;
  }
}

@media only screen and (min-width: 1200px) {
  .solution-icon h4 {
    padding: 0 14%;
    font-size: 42px;
  }

  .icon-wrapper svg {
    width: 6rem;
  }
}
</style>


// WEBPACK FOOTER //
// SolutionsButton.vue?3acfa6c5